{
  "close": "Zatvori",
  "notifications": "{count, plural, one {# obaveštenje} other {# obaveštenja}}."
}
